module.exports = __webpack_public_path__ + "static/media/Step1_dark2.117d5666.png";